// src/components/ExpenseListPage.js
import React, { useState, useEffect } from 'react';
import ExpenseList from './ExpenseList';
import ExpenseForm from './ExpenseForm';
import { getExpenses, deleteExpense, updateExpense } from '../api';
import './Dashboard.css';
import './ExpenseListPage.css';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx'; // 导入 xlsx 库

function ExpenseListPage() {
  const [expenses, setExpenses] = useState([]);
  const [editingExpense, setEditingExpense] = useState(null);
  const [sortBy, setSortBy] = useState('date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [expenseToDelete, setExpenseToDelete] = useState(null);

  useEffect(() => {
    const fetchExpenses = async () => {
      const data = await getExpenses();
      setExpenses(data);
    };
    fetchExpenses();
  }, []);

  const confirmDeleteExpense = async () => {
    if (expenseToDelete) {
      await deleteExpense(expenseToDelete);
      setExpenses(expenses.filter(expense => expense.id !== expenseToDelete));
      setShowDeleteConfirm(false);
    }
  };

  const handleDeleteExpense = (id) => {
    setExpenseToDelete(id);
    setShowDeleteConfirm(true);
  };

  const handleEditExpense = (expense) => {
    setEditingExpense(expense);
    setShowModal(true);
  };

  const handleUpdateExpense = async (updatedExpense) => {
    await updateExpense(updatedExpense);
    setExpenses(expenses.map(expense => (expense.id === updatedExpense.id ? updatedExpense : expense)));
    setEditingExpense(null);
    setShowModal(false);
  };

  const handleCancelEdit = () => {
    setEditingExpense(null);
    setShowModal(false);
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortOrder('asc');
    }
  };

  const exportToExcel = () => {
    // 创建一个工作簿
    const ws = XLSX.utils.json_to_sheet(expenses);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Expenses');

    // 导出 Excel 文件
    XLSX.writeFile(wb, 'expenses.xlsx');
  };

  const sortedExpenses = [...expenses].sort((a, b) => {
    const aValue = sortBy === 'date' ? new Date(a[sortBy]) : parseFloat(a[sortBy]);
    const bValue = sortBy === 'date' ? new Date(b[sortBy]) : parseFloat(b[sortBy]);
    return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
  });

  return (
    <div className="all-expenses">
      <div className="section expense-list-page">
        <div className="page-header">
          <Link to="/dashboard" className="back-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </Link>
          <h2 className="section-title">全部收支记录</h2>
          <button className="export-button" onClick={exportToExcel} style={{ marginLeft: 'auto' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00aaff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 20h16v-2H4z" />
              <path d="M12 4v12" />
              <path d="M9 7l3-3 3 3" />
            </svg>
          </button>
        </div>
        <div className="expense-list-container">
          <ExpenseList
            expenses={sortedExpenses}
            deleteExpense={handleDeleteExpense}
            editExpense={handleEditExpense}
            sortBy={sortBy}
            sortOrder={sortOrder}
            handleSort={handleSort}
          />
        </div>

        {showModal && (
          <div className="modal">
            <div className="modal-content">
              <ExpenseForm
                editingExpense={editingExpense}
                handleUpdateExpense={handleUpdateExpense}
                handleCancelEdit={handleCancelEdit}
              />
            </div>
          </div>
        )}

        {showDeleteConfirm && (
          <div className="modal-delete">
            <div className="modal-delete-content">
              <h3>确认删除</h3>
              <p>您确定要删除此支出记录吗？</p>
              <div className="modal-delete-buttons">
                <button className="modal-delete-confirm" onClick={confirmDeleteExpense}>确认</button>
                <button onClick={() => setShowDeleteConfirm(false)}>取消</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ExpenseListPage;
